/**
 * requires parent element with relative position for centering
 */
import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingOverlay = ({ animation, variant }) => (
	<div className="LoadingOverlay">
		<div id="middle">
			<div id="inner">
				<Spinner
					animation={animation ? animation : 'border'}
					variant={variant ? variant : 'primary'}
					role="status"
				/>
			</div>
		</div>
	</div>
);

export default LoadingOverlay;